import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { provideNgxMask } from 'ngx-mask';
import { CommonModule } from '@angular/common';
import { ParserHtmlPipe } from '../../parser-html.pipe';
import { SafeHtml } from '@angular/platform-browser';
import { OutsideClickDirective } from '../../outside-click.directive';

@Component({
    selector: 'app-alert-modal',
    imports: [FormsModule, ReactiveFormsModule, CommonModule, ParserHtmlPipe, OutsideClickDirective],
    templateUrl: './alert-modal.component.html',
    styleUrl: './alert-modal.component.scss',
    providers: [provideNgxMask()]
})
export class AlertModalComponent {
  @Input() message!: string;
  @Input() inProcess!: boolean;
  @Input() userData!: any;
  @Input() isSuccess!:boolean;
  @Input() showIcon=false;
  @Input() isHtml=false;
  @Output() onCancel:EventEmitter<any>= new EventEmitter<any>();
  @Output() onConfirm:EventEmitter<any>= new EventEmitter<any>();
  @Input() txtCancelButton:string="Cancelar";
  @Input() txtConfirmButton:string="Guardar";
@Input() hasButtons:boolean=false;

  cancelAction() {
    this.onCancel.emit();
   
    }


    confirmAction(){ 
    
      this.onConfirm.emit(); 
 
      }
    
      clickOutside(isOut: any) {
        if(!this.hasButtons){
          if (isOut) {
            this.cancelAction()
          }
        }
       
      }
    
  
}
